import * as React from 'react';

import { IconActionChevronDownSmall16, IconMapPin16 } from '@cian/ui-kit-design-tokens/icons';
import { FilterButtonV2 } from 'shared/components/FilterButtonV2';

import styles from './GeoSuggestV2.css';
import { useSelector } from 'react-redux';
import { selectPageType } from 'shared/selectors/page/selectPageType';
import { EPageType } from 'shared/types/page';

interface IGeoSuggestV2Props {
  label: string;
  onOpen: () => void;
}

export const GeoSuggestV2: React.FC<React.PropsWithChildren<IGeoSuggestV2Props>> = ({ label, onOpen, children }) => {
  const isMainPage = useSelector(selectPageType) === EPageType.MAIN;

  return (
    <div className={styles['container']}>
      <FilterButtonV2
        beforeIcon={<IconMapPin16 color="primary_100" />}
        afterIcon={<IconActionChevronDownSmall16 color="primary_100" />}
        onClick={onOpen}
        flexible={isMainPage}
      >
        {label}
      </FilterButtonV2>
      {children}
    </div>
  );
};
